import axios from "axios"
import config from "../config"

const BASE_URL = config.BASE_URL
const APIX = axios.create({
  baseURL: BASE_URL,
})

/**
 * Enregistre les métadonnées d'images en batch dans la base de données
 * @param {Object} data - Données à envoyer
 * @param {string} data.entityType - 'event' ou 'company'
 * @param {number} data.entityId - ID de l'entité
 * @param {Array} data.images - Tableau d'objets {path, url, isCover, position}
 * @returns {Promise<Object>} - Réponse de l'API
 */
export const saveImageMetadataBatch = async (data) => {
  try {
    console.log("saveImageMetadataBatch data : --->", data)
    const response = await APIX.post(`${BASE_URL}api/image/batch`, data)
    return response.data
  } catch (error) {
    console.error("Erreur saveImageMetadataBatch :", error)
    throw error
  }
}

/**
 * Enregistre les métadonnées d'images en batch dans la base de données pour
 * plusieurs événements
 * @param payload
 * @returns {Promise<any>}
 */
export const saveImageMetadataBatchMultipleEvents = async (payload) => {
  try {
    const response = await APIX.post(
      `${BASE_URL}api/image/batch-multiple-events`,
      payload
    )
    return response.data
  } catch (error) {
    console.error("Erreur saveImageMetadataBatch :", error)
    throw error
  }
}

/**
 * Supprime une image (Firebase + BDD)
 * @param {string} entityType - 'event' ou 'company'
 * @param {number} entityId - ID de l'entité
 * @param {number} imageId - ID de l'image
 * @returns {Promise<Object>} - Réponse de l'API
 */
export const deleteImage = async (entityType, entityId, imageId) => {
  try {
    const response = await APIX.delete(
      `${BASE_URL}api/image/remove/${entityType}/${entityId}/${imageId}`
    )
    return response.data
  } catch (error) {
    console.error("Erreur deleteImage :", error)
    throw error
  }
}

/**
 * Supprime tous les médias (Firebase + BDD)
 * @param {string} entityType - 'event' ou 'company'
 * @param {number} entityId - ID de l'entité
 * @param onlyRef
 * @returns {Promise<Object>} - Réponse de l'API
 */
export const removeAllMediaRef = async (entityType, entityId, onlyRef = true) => {
  try {
    const response = await APIX.delete(
      `${BASE_URL}api/image/remove-all/${entityType}/${entityId}/${onlyRef}`
    )
    return response.data
  } catch (error) {
    console.error("Erreur deleteImage :", error)
    throw error
  }
}

/**
 * Récupère toutes les images d'un event
 * @param {number} eventId - ID de l'event
 * @returns {Promise<Object>} - Réponse de l'API avec liste d'images
 */
export const getImageByEvent = async (eventId) => {
  try {
    const response = await APIX.get(`${BASE_URL}api/image/event/list/${eventId}`)
    return response.data
  } catch (error) {
    console.error("Erreur getImageByEvent :", error)
    throw error
  }
}

/**
 * Récupère la cover d'un event
 * @param {number} eventId - ID de l'event
 * @returns {Promise<Object>} - Réponse de l'API avec la cover
 */
export const getEventCover = async (eventId) => {
  try {
    const response = await APIX.get(`${BASE_URL}api/image/event/cover/${eventId}`)
    return response.data
  } catch (error) {
    console.error("Erreur getEventCover :", error)
    throw error
  }
}

/**
 * Récupère toutes les images d'une company
 * @param {number} companyId - ID de la company
 * @returns {Promise<Object>} - Réponse de l'API avec liste d'images
 */
export const getImageByCompany = async (companyId) => {
  try {
    const response = await APIX.get(`${BASE_URL}api/image/company/list/${companyId}`)
    return response.data
  } catch (error) {
    console.error("Erreur getImageByCompany :", error)
    throw error
  }
}

/**
 * Migration legacy : transfert d'une image serveur vers Firebase
 * @param {string} entityType - 'event' ou 'company'
 * @param {number} entityId - ID de l'entité
 * @param {string} imageUrl - URL de l'image à migrer
 * @returns {Promise<Object>} - Réponse de l'API
 */
export const legacyMigrationByServerUrlToFirebase = async (
  entityType,
  entityId,
  imageUrl
) => {
  try {
    const response = await APIX.post(`${BASE_URL}api/image/migrate`, {
      entityType,
      entityId,
      imageUrl,
    })
    return response.data
  } catch (error) {
    console.error("Erreur legacyMigrationByServerUrlToFirebase :", error)
    throw error
  }
}
